import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {SharedModule} from '../shared/shared.module';
import {InspectionDraftService} from "./services/inspection-draft.service";
import {CreateInspectionDialogComponent} from './dialogs/create-inspection-dialog/create-inspection-dialog.component';
import {EditInspectionDialogComponent} from './dialogs/edit-inspection-dialog/edit-inspection-dialog.component';
import {ConfirmThresholdDialogComponent} from './dialogs/confirm-threshold-dialog/confirm-threshold-dialog.component';
import {InspectionTableComponent} from './inspection-table/inspection-table.component';
import {OverlayModule} from "@angular/cdk/overlay";
import {LocaleDatePipe} from "../shared/pipes/locale-date.pipe";
import {InspectionItemComponent} from './inspection-item/inspection-item.component';
import {InspectionListComponent} from './inspection-list/inspection-list.component';
import {LocaleDecimalPipe} from "../shared/pipes/locale-decimal.pipe";
import {InspectionResultsDetailComponent} from "./inspection-results-details/inspection-results-detail.component";
import { InspectionDashboardComponent } from './inspection-dashboard/inspection-dashboard.component';
import {RouterLink} from "@angular/router";
import { InspectionDetailsDialogComponent } from './inspection-results-details/dialog/inspection-details-dialog/inspection-details-dialog.component';

@NgModule({
    declarations: [
        CreateInspectionDialogComponent,
        EditInspectionDialogComponent,
        ConfirmThresholdDialogComponent,
        InspectionTableComponent,
        InspectionItemComponent,
        InspectionListComponent,
        InspectionResultsDetailComponent,
        InspectionDashboardComponent,
        InspectionDetailsDialogComponent
    ],
    providers: [InspectionDraftService],
    imports: [CommonModule, SharedModule, OverlayModule, LocaleDatePipe, LocaleDecimalPipe, RouterLink],
    exports: [
        InspectionListComponent,
        InspectionResultsDetailComponent,
        InspectionDashboardComponent
    ]
})
export class InspectionModule {
}
